import { useAppSelector } from "../../../store/hooks";

export const useResolvedPaymentMethod = (paymentMethodId?: string | null) => {
  const paymentMethodsList = useAppSelector((state) => state.payment.methods.data);

  if (!paymentMethodId) {
    return undefined;
  }

  return paymentMethodsList.find((paymentMethod) => paymentMethod.id === paymentMethodId);
};

export const useResolvedAutopayPaymentMethod = (
  paymentMethodId?: string | null
) => {
  const accountSummary = useAppSelector((state) => state.accountSummary);
  const autopayPaymentMethodId =
    accountSummary.data?.[accountSummary.activeTenantAccountIndex]?.autopay
      ?.paymentMethodId;

  return useResolvedPaymentMethod(paymentMethodId ?? autopayPaymentMethodId);
};

export const useAutopayPaymentMethodDisplay = (
  paymentMethodDisplay?: string
) => {
  const paymentMethod = useResolvedAutopayPaymentMethod();

  if (paymentMethodDisplay) {
    return paymentMethodDisplay;
  }

  if (paymentMethod) {
    return paymentMethod.display;
  }

  return undefined;
};
